<template>
  <div class="user-list">
    <div class="search-bar">
      <el-input
        v-model="searchParam.keyword_search"
        placeholder="输入要搜索的内容"
        clearable
        @clear="getList"
      ></el-input>
      <!-- <el-date-picker
                v-model="daas"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="changeTime"
            >
            </el-date-picker> -->
      <el-button type="primary" @click="getList('clear')">查询</el-button>
      <el-button type="primary" @click="exportSign">导出</el-button>
    </div>
    <div class="table">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column prop="id" label="ID" fixed="left" width="120px"> </el-table-column>
        <el-table-column prop="username" label="用户昵称" width="120px"> </el-table-column>

        <el-table-column prop="archive_no" label="用户账号" width="120px"> </el-table-column>
        <el-table-column prop="sg_count" label="签到" width="120px"> </el-table-column>
        <el-table-column prop="cg_count" label="迟到" width="120px"> </el-table-column>

        <el-table-column prop="qg_count" label="缺席"> </el-table-column>

        <el-table-column label="操作" fixed="right" width="280">
          <template slot-scope="scope">
            <el-button class="mid-blue" @click="toDetail(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 60, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { signList, exportSign } from "@/api/edu.js";
import { getTeacherList } from "@/api/teacher.js";
import { mixin } from "@/mixins/pagination.js";
export default {
  mixins: [mixin],
  data() {
    return {
      loading: false,
      daas: [],
      teacherList: [],
      searchParam: {
        keyword_search: "",
        status: "2",
        start_time: "",
        end_time: "",
      },
      tableData: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    changeTime(val) {
      if (val) {
        this.searchParam = {
          ...this.searchParam,
          start_time: val[0],
          end_time: val[1],
        };
      } else {
        this.searchParam = {
          ...this.searchParam,
          start_time: "",
          end_time: "",
        };
        this.getList();
      }
    },
    getTeacher(keyword_search) {
      getTeacherList({ keyword_search }).then((res) => {
        if (res.data instanceof Array) {
          this.teacherList = res.data;
        }
      });
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/sign-record",
        query: row,
      });
    },

    setTop(row) {},
    xiajia(row) {},
    agree() {},
    noagree(row) {
      this.$confirm("确定要拒绝该申请吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {})
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    exportSign() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
      };
      exportSign(param);
    },
    async getList(type) {
      if (type == "clear") {
        this.page_index = 1;
      }
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
      };
      this.loading = true;
      const res = await signList(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
</style>
